export default __webpack_public_path__ + "static/media/asiacup-plopy.f9dbc7d9.png";